import { gql } from '__generated__';

export default gql(`
  query GetEventPickerEvents($project_id: ID!, $page: Int, $per_page: Int, $search: String) {
    project(id: $project_id) {
      id
      events(page: $page, per_page: $per_page, search: $search) {
        data {
          id
          title
          start_date
          active
        }
        current_page
        last_page
        per_page
        total
      }
    }
  }
`);
